import {ActionBuilder} from "@cuatroochenta/co-redux-builders";

export default ActionBuilder.build({
    setUsername: (email: string) => ({email}),
    setPassword: (password: string) => ({password}),
    setToken: (token: string) => ({token}),
});
